import { render } from "./index.md?vue&type=template&id=d43aade8"
import script from "./index.md?vue&type=script&lang=js"
export * from "./index.md?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__